import { allBlogPosts, type BlogPost } from '../../Blog/data/blogPostsData'

const isEnabled = (value: unknown) =>
  value === true || (typeof value === 'string' && value.trim().toLowerCase() === 'true')

const sortByNewest = (posts: BlogPost[]) =>
  [...posts].sort((first, second) => {
    const firstDate = first.frontmatter.date ? new Date(first.frontmatter.date).getTime() : 0
    const secondDate = second.frontmatter.date ? new Date(second.frontmatter.date).getTime() : 0

    return secondDate - firstDate
  })

export const getHomepageFeaturedCaseStudies = () =>
  sortByNewest(
    allBlogPosts.filter((post) => isEnabled(post.frontmatter.homepageFeaturedCaseStudy))
  ).sort((first, second) => {
    const firstOrder = first.frontmatter.homepageFeaturedCaseStudyOrder ?? Number.MAX_SAFE_INTEGER
    const secondOrder = second.frontmatter.homepageFeaturedCaseStudyOrder ?? Number.MAX_SAFE_INTEGER

    return firstOrder - secondOrder
  })

export const getHomepageInFocusPosts = (limit = 3) =>
  sortByNewest(allBlogPosts.filter((post) => isEnabled(post.frontmatter.homepageInFocus))).slice(
    0,
    limit
  )

export const formatHomepagePostDate = (value?: string) => {
  if (!value) return ''

  const date = new Date(value)

  return Number.isNaN(date.getTime())
    ? value
    : date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}
